import { serviceURL } from "../../../../../utils/service-url";
import type { UUID } from "../../../../../utils/uuid";

export function makeSurveyUrl(
  acc_id: string,
  surveyId: string,
  config: { anonymous: boolean },
): string {
  const tags = config.anonymous
    ? {}
    : {
        person_id: "{{person_id}}",
        moment_id: "{{moment_id}}",
        outbox_id: "{{outbox_id}}",
      };

  const data = {
    account_id: acc_id,
    survey_id: surveyId,
    anonymous: config.anonymous,
    preview: false,
    ...tags,
  };

  const jwtBlock = `{{#jwt}}${JSON.stringify(data)}{{/jwt}}`;
  return `${serviceURL("poll-position")}survey/jwt/${jwtBlock}`;
}

export function extractSurveyUrl(text: string): string | null {
  const surveyRegex =
    /(https?:\/\/[^\s]+\/survey\/[^\s"]+?(?:\/jwt\/[^\s"]+|{{#jwt}}[^\s]+{{\/jwt}}))/;
  const match = text.match(surveyRegex);
  return match ? match[0] : null;
}

export function getSurveyIdFromUrl(url?: string): UUID | null {
  if (!url) return null;

  const parsedUrl = decodeURIComponent(url);

  if (parsedUrl.includes("{{#jwt}}")) {
    const jwtMatch = parsedUrl.match(/survey\/jwt\/\{\{#jwt\}\}([^/]+)\{\{\/jwt\}\}/);
    const jwtData = jwtMatch ? (JSON.parse(jwtMatch[1]!) as { survey_id: UUID }) : null;
    return jwtData?.survey_id ?? null;
  }

  const regex =
    /\/survey\/[^/]+\/([^/]+)\/\{\{person_id\}\}\?moment_id=\{\{moment_id\}\}&outbox_id=\{\{outbox_id\}\}/;
  const match = parsedUrl.match(regex);
  return match ? (match[1] as UUID) : null;
}
